import { combineReducers } from "redux";
import {
  REQUEST_ANNOUNCEMENTS,
  RECEIVE_ANNOUNCEMENTS,
} from "@actions/action_consts";

const pages = (pages = {}, action = {}) => {
  Object.freeze(pages)
  switch (action.type) {
    case REQUEST_ANNOUNCEMENTS:
      return {
        ...pages,
        [action.params.page]: {
          items: [],
          fetching: true,
        },
      };
    case RECEIVE_ANNOUNCEMENTS:
      let list = action.announcements.list;
      return {
        ...pages,
        [action.params.page]: {
          items: list?.map((item) => item.id),
          fetching: false,
        },
      };

    default:
      return pages;
  }
};

const filter = (filter = {}, action = {}) => 
  action.type === REQUEST_ANNOUNCEMENTS ? (action.params.filter || {}) : filter;
const currentPage = (currentPage = 1, action = {}) =>
  action.type === REQUEST_ANNOUNCEMENTS ? (action.params.page || 1) : currentPage;
const total = (total = 0, action = {}) =>
  action.type === RECEIVE_ANNOUNCEMENTS ? action.announcements.total : total;


export const announcementsPagination = combineReducers({
  pages,
  currentPage,
  total,
  filter
});
